var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewProjectIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.351 5.833c0-.92-.746-1.666-1.667-1.666h-7.498c.033 0 .023-.013-.05-.103-.019-.021-.04-.048-.066-.08l-.16-.205a24.55 24.55 0 00-.101-.13C9.212 2.896 8.618 2.5 7.684 2.5h-5c-.92 0-1.666.746-1.666 1.667v11.666c0 .92.746 1.667 1.666 1.667h15c.92 0 1.667-.746 1.667-1.667v-10zm-1.667 0v10h-15V4.167h5c.32 0 .506.123.818.517l.073.094.198.252c.419.52.808.8 1.407.803h7.504z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.018 7.5H9.35V10h-2.5v1.667h2.5v2.5h1.667v-2.5h2.5V10h-2.5V7.5z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "media/images/new-project-icon-aceac498.svg";
export { SvgNewProjectIcon as ReactComponent };